import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { IconProps } from './types'

export const IconWrapper = styled.i<IconProps>`
  display: inline-block;

  ${({ color }) =>
    color &&
    css`
      color: ${color};
    `}

  svg {
    fill: currentColor;
  }

  ${({ width, height }) => `
    width: ${width};
    height: ${height};
  `}
`
